import { makeStyles, Theme, Typography, createStyles } from "@material-ui/core"
import React, { FC } from "react";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
   
    root: {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(12),
        width: 800,
        margin: "auto",
    },
    paragraph: {
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(2),
    }
  }),
);

const Support: FC = () => {
    const classes = useStyles();

    return <div className={classes.root}>
        <Typography variant="h4">
            Vivani - Support
        </Typography>
        
        <Typography variant="body1" className={classes.paragraph}>
            We would really like to hear your comments/concerns/suggestions/complains or to just Meet you :)
            
            <br /><br />
            The best way to contact us is over email: <a href="mailto:office@met.rs">office@meet.rs</a>.
            
            <br /><br />

            We have also <a href='http://twitter.com/meetrshq'>MeetrsHq twitter account</a> and <a href='https://www.linkedin.com/company/vivani'>Linkedin page</a> so you can contact us there too.
            
            
        </Typography>

        <Typography variant="body1" className={classes.paragraph}>
            This document was last updated on July 1, 2020          
        </Typography>
    </div>;
}

export default Support;